import React, { forwardRef } from "react";
import { calcAge, formatDate } from "../utils/helpers";

const Resume = forwardRef(({ applicant }, ref) => {
  if (!applicant) return null;
  const a = applicant;
  const full = `${a.firstName || ""} ${a.middleName || ""} ${a.lastName || ""}`.trim();
  const addr = a.address || {};
  const ed = a.education || {};

  return (
    <div ref={ref} className="printable" style={{ fontFamily: "Arial, sans-serif", fontSize: "11pt", color: "black", padding: "20mm" }}>
      <div style={{ display: "flex", gap: 20, alignItems: "flex-start", borderBottom: "3px solid #c8881b", paddingBottom: 14, marginBottom: 18 }}>
        {a.photoUrl && (
          <img src={a.photoUrl} alt="2x2" style={{ width: "1.2in", height: "1.2in", objectFit: "cover", border: "1px solid #999" }} />
        )}
        <div style={{ flex: 1 }}>
          <h1 style={{ fontSize: "22pt", margin: 0, color: "#0d0a08", fontFamily: "Georgia, serif" }}>{full.toUpperCase()}</h1>
          <div style={{ fontSize: "10pt", color: "#444", marginTop: 6 }}>
            {addr.exact && <div><i className="ti ti-map-pin"></i> {[addr.exact, addr.barangay, addr.city, addr.province, addr.region].filter(Boolean).join(", ")}</div>}
            <div style={{ marginTop: 4 }}>
              {a.contactNumber && <span>📞 {a.contactNumber}</span>}
              {a.email && <span style={{ marginLeft: 12 }}>✉ {a.email}</span>}
            </div>
          </div>
        </div>
      </div>

      {a.professionalObjective && (
        <section style={{ marginBottom: 16 }}>
          <h2 style={{ fontSize: "12pt", color: "#c8881b", borderBottom: "1px solid #ddd", paddingBottom: 3, marginBottom: 6 }}>PROFESSIONAL OBJECTIVE</h2>
          <p style={{ textAlign: "justify" }}>{a.professionalObjective}</p>
        </section>
      )}

      <section style={{ marginBottom: 16 }}>
        <h2 style={{ fontSize: "12pt", color: "#c8881b", borderBottom: "1px solid #ddd", paddingBottom: 3, marginBottom: 6 }}>PERSONAL INFORMATION</h2>
        <table style={{ fontSize: "10pt", width: "100%" }}>
          <tbody>
            <tr><td style={{ fontWeight: "bold", width: "30%" }}>Date of Birth:</td><td>{a.birthdate ? formatDate(a.birthdate) : "—"}</td></tr>
            <tr><td style={{ fontWeight: "bold" }}>Place of Birth:</td><td>{a.placeOfBirth || "—"}</td></tr>
            <tr><td style={{ fontWeight: "bold" }}>Age:</td><td>{calcAge(a.birthdate) || "—"}</td></tr>
            <tr><td style={{ fontWeight: "bold" }}>Gender:</td><td>{a.gender || "—"}</td></tr>
            <tr><td style={{ fontWeight: "bold" }}>Civil Status:</td><td>{a.civilStatus || "—"}</td></tr>
            <tr><td style={{ fontWeight: "bold" }}>Citizenship:</td><td>{a.citizenship || "—"}</td></tr>
            <tr><td style={{ fontWeight: "bold" }}>Languages:</td><td>{(a.languages || []).join(", ") || "—"}</td></tr>
          </tbody>
        </table>
      </section>

      <section style={{ marginBottom: 16 }}>
        <h2 style={{ fontSize: "12pt", color: "#c8881b", borderBottom: "1px solid #ddd", paddingBottom: 3, marginBottom: 6 }}>EDUCATIONAL BACKGROUND</h2>
        {["elementary", "secondary", "college"].map((k) => ed[k] && ed[k].schoolName ? (
          <div key={k} style={{ marginBottom: 8, fontSize: "10pt" }}>
            <div style={{ fontWeight: "bold", textTransform: "capitalize" }}>{k}</div>
            <div>{ed[k].schoolName}</div>
            <div style={{ color: "#666" }}>{ed[k].address}</div>
            <div style={{ color: "#666" }}>Graduated: {ed[k].monthGraduated ? `${ed[k].monthGraduated}/` : ""}{ed[k].yearGraduated || ""}</div>
          </div>
        ) : null)}
      </section>

      {(a.skills && a.skills.length > 0) && (
        <section style={{ marginBottom: 16 }}>
          <h2 style={{ fontSize: "12pt", color: "#c8881b", borderBottom: "1px solid #ddd", paddingBottom: 3, marginBottom: 6 }}>SKILLS</h2>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {a.skills.map((s, i) => (
              <span key={i} style={{ background: "#fdf8e8", border: "1px solid #efc04d", borderRadius: 4, padding: "2px 10px", fontSize: "10pt" }}>{s}</span>
            ))}
          </div>
        </section>
      )}

      {(a.workExperience && a.workExperience.length > 0) && (
        <section style={{ marginBottom: 16 }}>
          <h2 style={{ fontSize: "12pt", color: "#c8881b", borderBottom: "1px solid #ddd", paddingBottom: 3, marginBottom: 6 }}>WORK EXPERIENCE</h2>
          {a.workExperience.map((w, i) => (
            <div key={i} style={{ marginBottom: 10, fontSize: "10pt" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={{ fontWeight: "bold" }}>{w.jobRole}</span>
                <span style={{ color: "#666" }}>{w.startDate} – {w.endDate || "Present"}</span>
              </div>
              <div style={{ fontStyle: "italic", color: "#444" }}>{w.company}</div>
            </div>
          ))}
        </section>
      )}

      {(a.characterReferences && a.characterReferences.length > 0) && (
        <section>
          <h2 style={{ fontSize: "12pt", color: "#c8881b", borderBottom: "1px solid #ddd", paddingBottom: 3, marginBottom: 6 }}>CHARACTER REFERENCES</h2>
          {a.characterReferences.map((r, i) => (
            <div key={i} style={{ marginBottom: 8, fontSize: "10pt" }}>
              <div style={{ fontWeight: "bold" }}>{r.name}</div>
              <div>{r.position}{r.company ? `, ${r.company}` : ""}</div>
              <div style={{ color: "#666" }}>{r.contact}</div>
            </div>
          ))}
        </section>
      )}
    </div>
  );
});

export default Resume;
